import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHelperService } from './http-helper.service';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class DataServiceService {
  public countryList: any[] = [];
  
  constructor(public urlService: UrlService, public httpHelper: HttpHelperService) {
    // Countries will be loaded on-demand when needed, not on app startup
  }


   uploadFile(file:any){
      var formData:FormData=new FormData();
      formData.append('file',file);
     return this.httpHelper.postApiData(this.urlService.urls.fileUpload.fileUrl,formData,true);
  }


  //  user functions
  getAllUsers(): Observable<any> {
    return this.httpHelper.getApiData(this.urlService.urls.users.getAllUsers);
  }

  getUserById(id:any): Observable<any> {
    return this.httpHelper.getApiData(this.urlService.urls.users.getUserById+id);
  }

  createUser(data: any): Observable<any> {
    return this.httpHelper.postApiData(this.urlService.urls.users.createUser,data);
  }
  updateUser(data: any): Observable<any> {
    return this.httpHelper.putApiData(this.urlService.urls.users.updateUser,data);
  }

  createContact(data: any): Observable<any> {
    return this.httpHelper.postApiData(this.urlService.urls.users.createContact,data);
  }

  getContacts(): Observable<any> {
    return this.httpHelper.getApiData(this.urlService.urls.users.getContacts);
  }

   //  role functions
   getRoles(): Observable<any> {
    return this.httpHelper.getApiData(this.urlService.urls.roles.getRoles);
  }

  updateRoleByStatus(data:any): Observable<any> {
    return this.httpHelper.putApiData(this.urlService.urls.users.getUserById,data);
  }

  createRole(data: any): Observable<any> {
    return this.httpHelper.postApiData(this.urlService.urls.roles.createRole,data);
  }
  updateRole(data: any): Observable<any> {
    return this.httpHelper.putApiData(this.urlService.urls.roles.updateRole,data);
  }

    //  countries functions
    getCountries(): Observable<any> {
      return this.httpHelper.getApiData(this.urlService.urls.country.getCountries);
    }

    updateCountryStatus(data:any): Observable<any> {
      return this.httpHelper.putApiData(this.urlService.urls.country.updateCountryStatus,data);
    }

    createCountry(data: any): Observable<any> {
      return this.httpHelper.postApiData(this.urlService.urls.country.createCountry,data);
    }
    updateCountry(data: any): Observable<any> {
      return this.httpHelper.putApiData(this.urlService.urls.country.updateCountry,data);
    }

    //  states functions
    getStates(): Observable<any> {
      return this.httpHelper.getApiData(this.urlService.urls.states.getStates);
    }

    getStatesByCountryId(countryId:any): Observable<any> {
      return this.httpHelper.getApiData(this.urlService.urls.states.getStatesByCountryId+countryId);
    }

    getStatesById(id:any): Observable<any> {
      return this.httpHelper.getApiData(this.urlService.urls.states.getStatesById+id);
    }
    updateStateStatus(data:any): Observable<any> {
      return this.httpHelper.putApiData(this.urlService.urls.states.updateStateStatus,data);
    }

    createState(data: any): Observable<any> {
      return this.httpHelper.postApiData(this.urlService.urls.states.createState,data);
    }
    updateState(data: any): Observable<any> {
      return this.httpHelper.putApiData(this.urlService.urls.states.updateState,data);
    }


     //  cities functions
     getCities(): Observable<any> {
      return this.httpHelper.getApiData(this.urlService.urls.cities.getCities);
    }

    getCitiesByStateId(stateId:any): Observable<any> {
      return this.httpHelper.getApiData(this.urlService.urls.cities.getCitiesByStateId+stateId);
    }

    updateCityStatus(data:any): Observable<any> {
      return this.httpHelper.putApiData(this.urlService.urls.cities.updateCityStatus,data);
    }

    createCity(data: any): Observable<any> {
      return this.httpHelper.postApiData(this.urlService.urls.cities.createCity,data);
    }
    updateCity(data: any): Observable<any> {
      return this.httpHelper.putApiData(this.urlService.urls.cities.updateCity,data);
    }

     //  cities functions
     getPropertyType(): Observable<any> {
      return this.httpHelper.getApiData(this.urlService.urls.propertyTypes.getPropertyType);
    }


    updatePropertyTypeStatus(data:any): Observable<any> {
      return this.httpHelper.putApiData(this.urlService.urls.propertyTypes.updatePropertyTypeStatus,data);
    }

    createPropertyType(data: any): Observable<any> {
      return this.httpHelper.postApiData(this.urlService.urls.propertyTypes.createPropertyType,data);
    }
    updatePropertyType(data: any): Observable<any> {
      return this.httpHelper.putApiData(this.urlService.urls.propertyTypes.updatePropertyType,data);
    }

      //  developers functions
      getAllDevelopers(): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.developers.getDevelopers);
      }
      getDevelopersWithProjectCount(data:any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.developers.getDevelopersWithProjectCount,data);
      }
      getDeveloperById(data:any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.developers.getDeveloperById,data);
      }


      updateDevelopersStatus(data:any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.developers.updateDeveloperStatus,data);
      }

      createDevelopers(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.developers.createDeveloper,data);
      }
      updateDevelopers(data: any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.developers.updateDeveloper,data);
      }

       //  community functions
       getAllCommunity(): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.community.getCommunity);
      }

      getCommunityWithProjectCount(data:any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.community.getCommunityWithProjectCount,data);
      }

      getCommunityById(data:any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.community.getCommunityById,data);
      }



      updateCommunityStatus(data:any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.community.updateCommunityStatus,data);
      }

      createCommunity(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.community.createCommunity,data);
      }
      updateCommunity(data: any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.community.updateCommunity,data);
      }

       //  feature functions
       getAllFeature(types?:any): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.feature.getFeatures+(types?.length > 0 ? '?types='+types:''));
      }

      updateFeatureStatus(data:any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.feature.updateFeatureStatus,data);
      }

      createFeature(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.feature.createFeature,data);
      }
      updateFeature(data: any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.feature.updateFeature,data);
      }
       //  internal external feature functions
       getAllInternalExternalFeature(): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.internalExternalFeature.getFeatures);
      }

      updateInternalExternalFeatureStatus(data:any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.internalExternalFeature.updateFeatureStatus,data);
      }

      createInternalExternalFeature(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.internalExternalFeature.createFeature,data);
      }
      updateInternalExternalFeature(data: any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.internalExternalFeature.updateFeature,data);
      }
       //  location functions
       getAllLocation(): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.location.getLocation);
      }

      getLocation(): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.location.getAllLocation);
      }

      getLocationDetails(data:any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.location.getLocationDetails,data);
      }

      getLocationById(data:any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.location.getLocationById,data);
      }


      getAllLocationByCityId(id:any): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.location.getLocationByCityId+id);
      }

      updateLocationStatus(data:any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.location.updateLocationStatus,data);
      }

      createLocation(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.location.createLocation,data);
      }
      updateLocation(data: any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.location.updateLocation,data);
      }

       //  news article category functions
       getNewsArticlesCategory(): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.newArticleCategory.getNewsArticlesCategory);
      }

      updateNewArticleCategoryStatus(data:any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.newArticleCategory.updateNewArticleCategoryStatus,data);
      }

      createNewArticleCategory(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.newArticleCategory.createNewArticleCategory,data);
      }
      updateNewArticleCategory(data: any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.newArticleCategory.updateNewArticleCategory,data);
      }

      getNewsArticles(): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.newsArticle.getNewsArticles);
      }

      createNewsArticles(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.newsArticle.createNewsArticles,data);
      }
      updateNewArticles(data:any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.newsArticle.updateNewArticles,data);
      }

      getNewsArticlesById(id:any): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.newsArticle.getNewsArticleById+id);
      }

      getNewsArticleForClient(params?: any): Observable<any> {
        let url = this.urlService.urls.newsArticle.getNewsArticleForClient;
        
        // Add query parameters if provided
        if (params) {
          const queryParams = new URLSearchParams();
          if (params.page) queryParams.append('page', params.page.toString());
          if (params.limit) queryParams.append('limit', params.limit.toString());
          
          const queryString = queryParams.toString();
          if (queryString) {
            url += `?${queryString}`;
          }
        }
        
        return this.httpHelper.getApiData(url);
      }

      getNewsArticlesForClientById(data:any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.newsArticle.getNewsArticlesForClientById,data);
      }

       //  news article category functions
       getProperties(): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.properties.getProperties);
      }
      getPropertiesById(id:any): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.properties.getPropertyById+id);
      }
      createProperty(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.properties.createProperty,data);
      }

      updateProperty(data:any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.properties.updateProperty,data);
      }

      updatePropertyStatus(data: any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.properties.updatePropertyStatus,data);
      }

       //  projects
       getProjects(param?:any): Observable<any> {
        let url;
        if(param?.isShort){
        url=this.urlService.urls.project.getProjects+'?isShort=true';
        }else{
          url=this.urlService.urls.project.getProjects;
        }
        return this.httpHelper.getApiData(url);
      }
      getAllProjects(): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.project.getAllProjects);
      }

      getAllProperty():Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.properties.getAllProperty);
      }
      getProjectById(id:any): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.project.getProjectById+id);
      }
      getProjectByIdInDetails(obj:any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.project.getProjectByIdInDetails,obj);
      }

      getAllProjectGallery(id:any): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.project.getAllProjectGallery+id);
      }

      createProject(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.project.createProject,data);
      }

      getProjectsBaseOnFilter(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.project.getProjectsBaseOnFilter,data);
      }


      getProjectsBaseOnPropertyTypeFilter(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.project.getProjectsBaseOnPropertyTypeFilter,data);
      }

      createProjectGallery(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.project.createProjectGallery,data);
      }

      createProjectFeature(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.project.createProjectFeature,data);
      }
      getProjectFeatureById(id:any): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.project.getFeatureByProjectId+id);
      }
      updateProject(data:any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.project.updateProject,data);
      }

      deleteProjectFeature(data:any):Observable<any> {
        return this.httpHelper.deleteApiData(this.urlService.urls.project.deleteProjectFeature,data);
      }




      updateProjectStatus(data: any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.project.updateProjectStatus,data);
      }
      createProjectPaymentPlanSection(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.project.createPaymentPlanSection,data);
      }

      getProjectPaymentPlanSectionById(id:any): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.project.getPaymentPlanSectionByProjectId+id);
      }

      createFeatureParentSection(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.project.createFeatureParentSection,data);
      }

      getFeatureParentByProjectId(id:any): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.project.getFeatureParentByProjectId+id);
      }


      getPaymentPlanParentByProjectId(id:any): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.project.getPaymentPlanParentByProjectId+id);
      }

      createPaymentPlanParentSection(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.project.createPaymentPlanParentSection,data);
      }

       //  floor plan
       getFloorPlan(id:any): Observable<any> {
        return this.httpHelper.getApiData(this.urlService.urls.floorPlans.getFloorPlan+id);
      }

      createFloorPlan(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.floorPlans.createFloorPlan,data);
      }
      createFloorPlanItem(data: any): Observable<any> {
        return this.httpHelper.postApiData(this.urlService.urls.floorPlans.createFloorPlanItem,data);
      }

      deleteFloorPlanItem(data:any):Observable<any> {
        return this.httpHelper.deleteApiData(this.urlService.urls.floorPlans.deleteFloorPlanItem,data);
      }

      updateFloorPlanItem(data:any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.floorPlans.updateFloorPlanItem,data);
      }

      updateFloorPlanStatus(data: any): Observable<any> {
        return this.httpHelper.putApiData(this.urlService.urls.floorPlans.updateFloorPlanStatus,data);
      }

        //  location map
        getLocationMap(id:any): Observable<any> {
          return this.httpHelper.getApiData(this.urlService.urls.locationMap.getLocationMap+id);
        }

        createLocationMap(data: any): Observable<any> {
          return this.httpHelper.postApiData(this.urlService.urls.locationMap.createLocationMap,data);
        }

        updateLocationMap(data:any): Observable<any> {
          return this.httpHelper.putApiData(this.urlService.urls.locationMap.updateLocationMap,data);
        }

        updateLocationMapStatus(data: any): Observable<any> {
          return this.httpHelper.putApiData(this.urlService.urls.locationMap.updateLocationMapStatus,data);
        }

        deleteLocationMap(data:any):Observable<any> {
          return this.httpHelper.deleteApiData(this.urlService.urls.project.deleteProjectFeature,data);
        }

         //  locationNearPlaces

         createLocationNearPlaces(data: any): Observable<any> {
          return this.httpHelper.postApiData(this.urlService.urls.locationNearPlaces.createLocationNearPlaces,data);
        }

        updateLocationNearPlaces(data:any): Observable<any> {
          return this.httpHelper.putApiData(this.urlService.urls.locationNearPlaces.updateLocationNearPlaces,data);
        }


         //  master plan
         getMasterPlan(id:any): Observable<any> {
          return this.httpHelper.getApiData(this.urlService.urls.masterPlans.getMasterPlan+id);
        }

        createMasterPlan(data: any): Observable<any> {
          return this.httpHelper.postApiData(this.urlService.urls.masterPlans.createMasterPlan,data);
        }

        updateMasterPlan(data:any): Observable<any> {
          return this.httpHelper.putApiData(this.urlService.urls.masterPlans.updateMasterPlan,data);
        }

        updateMasterPlanStatus(data: any): Observable<any> {
          return this.httpHelper.putApiData(this.urlService.urls.masterPlans.updateMasterPlanStatus,data);
        }

        deleteMasterItem(data:any):Observable<any> {
          return this.httpHelper.deleteApiData(this.urlService.urls.masterPlans.deleteMasterItem,data);
        }


        //  locationNearPlaces

        createMasterPlanItems(data: any): Observable<any> {
          return this.httpHelper.postApiData(this.urlService.urls.masterPlanItems.createMasterPlanItems,data);
        }

        updateMasterPlanItems(data:any): Observable<any> {
          return this.httpHelper.putApiData(this.urlService.urls.masterPlanItems.updateMasterPlanItems,data);
        }

         //  paymentPlan
         getProjectPaymentPlan(): Observable<any> {
          return this.httpHelper.getApiData(this.urlService.urls.paymentPlan.getProjectPaymentPlan);
        }

        createProjectPaymentPlan(data: any): Observable<any> {
          return this.httpHelper.postApiData(this.urlService.urls.paymentPlan.createProjectPaymentPlan,data);
        }

        updateProjectPaymentPlan(data:any): Observable<any> {
          return this.httpHelper.putApiData(this.urlService.urls.paymentPlan.updateProjectPaymentPlan,data);
        }

        updateProjectPaymentStatus(data: any): Observable<any> {
          return this.httpHelper.putApiData(this.urlService.urls.paymentPlan.updateProjectPaymentStatus,data);
        }

        deleteProjectPaymentPlan(data: any): Observable<any> {
          return this.httpHelper.deleteApiData(this.urlService.urls.paymentPlan.deletePaymentPlan,data);
        }

         //  paymentPlanTypes
         getProjectPlanType(): Observable<any> {
          return this.httpHelper.getApiData(this.urlService.urls.paymentPlanTypes.getProjectPlanType);
        }

        createProjectPlanType(data: any): Observable<any> {
          return this.httpHelper.postApiData(this.urlService.urls.paymentPlanTypes.createProjectPlanType,data);
        }

        updateProjectPlanType(data:any): Observable<any> {
          return this.httpHelper.putApiData(this.urlService.urls.paymentPlanTypes.updateProjectPlanType,data);
        }

        updateProjectPlanTypeStatus(data: any): Observable<any> {
          return this.httpHelper.putApiData(this.urlService.urls.paymentPlanTypes.updateProjectPlanTypeStatus,data);
        }

         //  paymentPlanCriteria
         getProjectPaymentCriteria(id:any): Observable<any> {
          return this.httpHelper.getApiData(this.urlService.urls.paymentPlanCriteria.getProjectPaymentCriteria+id);
        }

        createProjectPaymentCriteria(data: any): Observable<any> {
          return this.httpHelper.postApiData(this.urlService.urls.paymentPlanCriteria.createProjectPaymentCriteria,data);
        }

        updatePaymentCriteria(data:any): Observable<any> {
          return this.httpHelper.putApiData(this.urlService.urls.paymentPlanCriteria.updatePaymentCriteria,data);
        }

        updatePaymentCriteriaStatus(data: any): Observable<any> {
          return this.httpHelper.putApiData(this.urlService.urls.paymentPlanCriteria.updatePaymentCriteriaStatus,data);
        }

         //  landing home
         getProjectsBaseOnType(): Observable<any> {
          return this.httpHelper.getApiData(this.urlService.urls.landingPage.getProjectsBaseOnType);
        }
        getDeveloperWithProjectCount(): Observable<any> {

          return this.httpHelper.getApiData(this.urlService.urls.landingPage.getDeveloperWithProjectCount);
        }
        getCommunity(): Observable<any> {
          return this.httpHelper.getApiData(this.urlService.urls.landingPage.getCommunity);
        }
        getStateWithProjectsCount(): Observable<any> {
          return this.httpHelper.getApiData(this.urlService.urls.landingPage.getStateWithProjectsCount);
        }
        getLatestProject(): Observable<any> {
          return this.httpHelper.getApiData(this.urlService.urls.landingPage.getLatestProject);
        }

         getUpcomingProject(): Observable<any> {
          return this.httpHelper.getApiData(this.urlService.urls.landingPage.getUpcomingProject);
        }

        getPropertyTypeCount(): Observable<any> {
          return this.httpHelper.getApiData(this.urlService.urls.landingPage.getPropertyTypeCount);
        }

        getPropertyTypeCommunityCount(): Observable<any> {
          return this.httpHelper.getApiData(this.urlService.urls.landingPage.getPropertyTypeCommunityCount);
        }

        // services
        getService(): Observable<any> {
          return this.httpHelper.getApiData(this.urlService.urls.services.getService);
        }

        updateService(data: any): Observable<any> {
          return this.httpHelper.putApiData(this.urlService.urls.services.updateService,data);
        }

        updateServiceTab(data: any): Observable<any> {
          return this.httpHelper.putApiData(this.urlService.urls.services.updateServiceTab,data);
        }

        createServiceItem(data: any): Observable<any> {
          return this.httpHelper.postApiData(this.urlService.urls.services.createServiceItem,data);
        }

        deleteService(data: any): Observable<any> {
          return this.httpHelper.deleteApiData(this.urlService.urls.services.deleteService,data);
        }

        createServiceTabs(data: any): Observable<any> {
          return this.httpHelper.postApiData(this.urlService.urls.services.createServiceTabs,data);
        }


}
